import API from '../infraestructure/api';
import ApiError from './apiError';

export async function getServiceStates(data = '') {
  try {
    const response = await API.get(`/state${data}`);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/states/', message: `Hubo un problema al intentar buscar estados. ${message}` });
  }
}
